<template>
  <div class="nexus-layout-wrapper">
    <!-- Escritorio (≥1264): columna fija. Tablet y móvil: flota sobre el
         contenido, cerrado por defecto, con scrim, y se cierra al navegar. -->
    <v-navigation-drawer
      v-model="drawer"
      :permanent="esEscritorio"
      :temporary="!esEscritorio"
      :fixed="!esEscritorio"
      :width="$vuetify.breakpoint.smAndDown ? 300 : anchoConfigurado"
      :mini-variant="isMiniVariant"
      floating
      class="nexus-sidebar custom-scroll-internal"
      :class="{ 'nexus-sidebar--flotante': !esEscritorio }"
      :style="estiloSidebar"
    >
      <template v-slot:prepend>
        <div class="nexus-sidebar-top">
          <div class="d-flex align-center justify-space-between">
            <v-btn v-if="routeBack" x-small text color="grey" @click="handleRouteBack">
              <v-icon left x-small>mdi-arrow-left</v-icon> {{ routeBackLabel }}
            </v-btn>
            <span v-else></span>
            <v-btn v-if="!esEscritorio" icon small @click="drawer = false">
              <v-icon color="grey lighten-1">mdi-close</v-icon>
            </v-btn>
          </div>

          <slot name="title"></slot>
          <div v-if="!isMiniVariant && showListPrepend">
            <slot name="navigation-subtitle"></slot>
            <div class="white--text text-h5 font-weight-black line-height-tight">
              <slot name="navigation-title"></slot>
            </div>
            <slot name="navigation-subtitle-after"></slot>
          </div>
        </div>
      </template>

      <div class="nexus-sidebar-body">
        <slot name="navigation-content"></slot>
      </div>

      <v-list nav dense class="nexus-nav px-3 pb-12">
        <slot name="navigation-before-links"></slot>

        <template v-for="(link, i) in linksMenu">
          <!-- Encabezado de sección -->
          <div v-if="link.header" :key="`h-${i}`" class="nexus-seccion">{{ link.header }}</div>

          <!-- Grupo desplegable: abierto si contiene la ruta actual -->
          <v-list-group
            v-else-if="link.children && link.children.length"
            :key="`g-${i}`"
            :value="grupoActivo(link)"
            no-action
            :prepend-icon="link.icon"
            color="#e3b08a"
            class="nexus-grupo"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="nexus-link-texto">{{ link.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, j) in link.children"
              :key="`c-${i}-${j}`"
              :to="{ name: child.route_name }"
              link
              class="nexus-sublink"
              active-class="nexus-activo"
            >
              <v-list-item-content>
                <v-list-item-title class="nexus-sublink-texto">{{ child.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- Link simple -->
          <v-list-item
            v-else
            :key="`l-${i}`"
            :to="{ name: link.route_name }"
            :exact="link.exact"
            link
            class="nexus-link"
            active-class="nexus-activo"
          >
            <v-list-item-icon><v-icon>{{ link.icon }}</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="nexus-link-texto">{{ link.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <slot name="navigation-after-links"></slot>
      </v-list>
    </v-navigation-drawer>

    <div class="nexus-main-container custom-scroll-internal" :style="esEscritorio ? { marginLeft: anchoSidebar + 'px' } : null">
      <!-- Barra para abrir el menú en tablet y móvil -->
      <div v-if="!esEscritorio" class="nexus-mobile-bar">
        <v-btn icon @click="drawer = !drawer" class="mr-2">
          <v-icon color="white">mdi-menu</v-icon>
        </v-btn>
        <slot name="mobile-header-title"><span class="nexus-mobile-titulo">{{ mobileTitle }}</span></slot>
      </div>

      <v-container
        fluid
        class="nexus-container-reset"
        :class="[
          $vuetify.breakpoint.smAndDown ? 'pa-4 pb-16' : 'pa-10',
          {'has-fab-padding': $vuetify.breakpoint.smAndDown}
        ]"
      >
        <transition name="fade-transition" mode="out-in">
          <div class="full-width-view">
            <slot name="vista-previa">
              <router-view />
            </slot>
          </div>
        </transition>
      </v-container>

      <slot name="mobile-floating-actions"></slot>
    </div>
  </div>
</template>

<style scoped>
.nexus-layout-wrapper {
  display: flex;
  min-height: 100vh;
  background-color: #000;
}

.nexus-sidebar {
  background-color: #0f0f0f !important;
  border-right: 1px solid rgba(255, 255, 255, 0.05) !important;
  flex-shrink: 0;
}
/* Escritorio: una columna más del flex, del alto de la pantalla */
@media (min-width: 1264px) {
  .nexus-sidebar {
    /* Fijo bajo la barra superior mientras el contenido scrollea;
       top/height los pone :style, el contenedor principal deja el margen */
    position: fixed !important;
    left: 0;
    display: flex;
    flex-direction: column;
    transform: none !important;
    visibility: visible !important;
  }
}
/* Tablet y móvil: flota por debajo de la barra superior (70px) */
.nexus-sidebar--flotante {
  z-index: 6;
}

.nexus-sidebar-top {
  padding: 12px 16px 4px;
}
.nexus-sidebar-body {
  padding: 4px 16px 0;
}

.nexus-main-container {
  flex: 1;
  min-width: 0;
  background-color: #121212;
  display: flex;
  flex-direction: column;
}
.nexus-mobile-bar {
  display: flex;
  align-items: center;
  padding: 8px 12px 0;
}
.nexus-mobile-titulo {
  color: #fff;
  font-weight: 600;
  font-size: 15px;
}

.nexus-container-reset {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
}
.has-fab-padding {
  padding-bottom: 120px !important;
}

/* La cabecera (prepend) no scrollea */
.nexus-sidebar ::v-deep .v-navigation-drawer__prepend {
  flex: 0 0 auto;
}
.custom-scroll-internal::-webkit-scrollbar,
.nexus-sidebar ::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
  width: 6px;
}
.custom-scroll-internal::-webkit-scrollbar-thumb,
.nexus-sidebar ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.3);
  border-radius: 10px;
}

/* Navegación */
.nexus-seccion {
  font-size: 11px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #6f6f6f;
  padding: 14px 12px 6px;
}
.nexus-link,
.nexus-grupo ::v-deep .v-list-group__header {
  border-radius: 10px !important;
  min-height: 40px;
}
.nexus-link ::v-deep .v-list-item__icon,
.nexus-grupo ::v-deep .v-list-group__header .v-list-item__icon {
  margin: 8px 12px 8px 0 !important;
}
.nexus-link-texto {
  color: #e6e6e6;
  font-size: 14px;
  font-weight: 500;
}
.nexus-sublink {
  padding-left: 44px !important;
  min-height: 36px;
  border-radius: 10px !important;
}
.nexus-sublink-texto {
  color: #b5b5b5;
  font-size: 13.5px;
}
.nexus-activo {
  background: rgba(186, 107, 48, 0.16) !important;
}
.nexus-activo .nexus-link-texto,
.nexus-activo .nexus-sublink-texto {
  color: #fff !important;
}
.nexus-activo ::v-deep .v-icon {
  color: #e3b08a !important;
}
</style>

<script>
export default {
  name: "LayoutBasic",
  props: {
    // Ítems: { name, icon, route_name, exact? } | { ...con children } | { header }
    linksMenu: { type: Array, default: () => [] },
    isMiniVariant: { type: Boolean, default: false },
    showListPrepend: { type: Boolean, default: true },
    // Algunos layouts lo pasan como "400px": se normaliza en anchoSidebar
    width: { type: [Number, String], default: 280 },
    routeBack: { type: [String, Object, Number], required: false },
    routeBackLabel: { type: String, default: "Volver" },
    mobileTitle: { type: String, default: "Menú" },
  },
  data() {
    return { drawer: false };
  },
  computed: {
    esEscritorio() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    // "400px" → 400; si no es un número válido, el default
    anchoConfigurado() {
      const ancho = parseInt(this.width, 10);
      return Number.isNaN(ancho) ? 280 : ancho;
    },
    anchoSidebar() {
      return this.isMiniVariant ? 56 : this.anchoConfigurado;
    },
    // Debajo de la app-bar, mida lo que mida (70 en escritorio, 56 en móvil)
    estiloSidebar() {
      const top = this.$vuetify.application.top || 70;
      return { top: `${top}px`, height: `calc(100vh - ${top}px)` };
    },
  },
  watch: {
    // Al elegir una pantalla en tablet/móvil el menú se cierra solo
    $route() {
      if (!this.esEscritorio) this.drawer = false;
    },
    esEscritorio(valor) {
      // Después de que Vuetify procese el cambio permanent → temporary
      if (!valor) this.$nextTick(() => (this.drawer = false));
    },
  },
  methods: {
    grupoActivo(link) {
      const actual = this.$route.name || "";
      if (link.children.some((c) => c.route_name && actual.startsWith(c.route_name))) return true;
      // Pantallas hijas no listadas (detalle, editar): comparten el espacio de
      // nombres del grupo. Se exige un prefijo de al menos 3 segmentos para que
      // "empresa.sucursal.x" no active todos los grupos.
      if (!link.route_name) return false;
      const partes = link.route_name.split(".");
      const prefijo = (partes.length > 3 ? partes.slice(0, -1) : partes).join(".") + ".";
      return prefijo.split(".").length > 3 && actual.startsWith(prefijo);
    },
    handleRouteBack() {
      if (typeof this.routeBack === "object") this.$router.push({ name: this.routeBack.name });
      else if (typeof this.routeBack === "string") this.$router.push(this.routeBack);
      else if (typeof this.routeBack === "number") this.$router.go(-1);
    },
  },
};
</script>
